

import React, { memo } from 'react';
import { Progress } from 'react-sweet-progress';
import cx from 'classnames';
import { Icon, COLOURS } from '../../../../../ui-kit';
import 'react-sweet-progress/lib/style.css';
import { getUploadProgress } from '../utils';
import '../styles/_progress.scss';

const progressTheme = (removeIcon) => ({
  default: {
    symbol: removeIcon
  },
  active: {
    symbol: removeIcon,
    color: COLOURS.cyan.jungleGreen.monkey
  },
  success: {
    symbol:
    <Icon
      name="success"
      size={12}
      color="monkey" />,


    color: COLOURS.cyan.jungleGreen.monkey
  },
  error: {
    symbol: removeIcon,
    color: COLOURS.red.redApple
  }
});












function ProgressSummary({
  loadedPercent,
  loaded, total,
  removeUploadItem,
  status,
  hideProgressValue,
  hideIcon = false,
  indeterminate = false
}) {
  const removeIcon =
  <Icon name="close" size={12} color="regent" onClick={removeUploadItem} hoverColor="redApple" />;


  // Ensure percent is a valid number
  const displayPercent = typeof loadedPercent === 'number' ?
  Math.max(0, Math.min(100, loadedPercent)) :
  0;

  // Determine correct status - default to 'active' during upload
  const getDisplayStatus = () => {
    if (status === 'error') return 'error';
    if (displayPercent < 100) return 'active'; // Most important change: use 'active' while uploading
    return 'success'; // Return 'success' when upload is complete
  };

  const displayStatus = getDisplayStatus();

  return (
    <>
      <Progress
        theme={progressTheme(removeIcon)}
        percent={status === 'error' && !displayPercent ? 100 : displayPercent}
        status={displayStatus}
        className={cx(
          'progress',
          hideIcon ? 'progress--hide-icon' : null,
          indeterminate ? 'progress--indeterminate' : null,
          'progress--animated'
        )} />

      {
      hideProgressValue ?
      null :

      <span className={cx('progress__value', { 'progress__value--none': loaded === 0 })}>
              {`${getUploadProgress(loaded, total, loadedPercent)}`}
            </span>}


    </>);

}

function arePropsEqual(prevProps, nextProps) {
  return (
    prevProps.loadedPercent === nextProps.loadedPercent &&
    prevProps.loaded === nextProps.loaded &&
    prevProps.total === nextProps.total &&
    prevProps.status === nextProps.status &&
    prevProps.hideProgressValue === nextProps.hideProgressValue &&
    prevProps.hideIcon === nextProps.hideIcon &&
    prevProps.indeterminate === nextProps.indeterminate);

}

export default memo(ProgressSummary, arePropsEqual);